module.exports = __webpack_public_path__ + "static/media/item_14_5_comp.cc2eef2a.png";